import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const Paywall = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Load the Stripe Pricing Table script if not already present
    if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/pricing-table.js';
      script.async = true;
      document.head?.appendChild(script);
    }
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col items-center px-4 sm:px-6 py-8 sm:py-12"
      style={{
        background: 'radial-gradient(ellipse at 30% 20%, #2a0000 0%, #111111 40%, #0a0a0a 70%, #111111 100%)',
      }}
    >
      {/* Top accent stripe */}
      <div
        className="fixed top-0 left-0 right-0 h-1"
        style={{
          background: 'linear-gradient(90deg, #AA0000, #FFD700, #CC0000)',
          boxShadow: '0 2px 12px rgba(255,215,0,0.4)',
        }}
      />
      {/* Ambient layer */}
      <div
        className="fixed inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(204,0,0,0.08) 0%, transparent 70%)' }}
      />
      {/* Brand header */}
      <div className="text-center mb-8 sm:mb-10 w-full max-w-5xl">
        <button
          onClick={() => navigate('/login')}
          className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-2xl mb-3 sm:mb-4"
          style={{
            background: 'linear-gradient(145deg, #E00000 0%, #CC0000 50%, #990000 100%)',
            boxShadow: '0 1px 0 rgba(255,100,100,0.4) inset, 0 -3px 0 rgba(80,0,0,0.6) inset, 0 8px 24px rgba(204,0,0,0.5)',
          }}
        >
          <Icon name="Wrench" size={32} className="sm:hidden" color="white" />
          <Icon name="Wrench" size={38} className="hidden sm:block" color="white" />
        </button>
        <h1
          className="text-3xl sm:text-4xl font-bold tracking-widest uppercase"
          style={{ color: '#FFFFFF', letterSpacing: '0.15em', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}
        >
          SERVICE<span style={{ color: '#FFD700', textShadow: '0 2px 8px rgba(255,215,0,0.4)' }}>JOCKEY</span>
        </h1>
        <div className="flex items-center justify-center gap-2 mt-2">
          <div className="h-px w-8 sm:w-12" style={{ background: 'linear-gradient(90deg, transparent, #CC0000)' }} />
          <p className="text-xs font-semibold uppercase tracking-widest" style={{ color: '#FFD700' }}>
            Choose Your Plan
          </p>
          <div className="h-px w-8 sm:w-12" style={{ background: 'linear-gradient(90deg, #CC0000, transparent)' }} />
        </div>
        {/* Trial period assurance message */}
        <div
          className="w-full max-w-3xl mx-auto mt-5 px-6 py-5 rounded-xl text-center"
          style={{
            background: 'rgba(255,215,0,0.06)',
            border: '1px solid rgba(255,215,0,0.2)',
            boxShadow: '0 2px 16px rgba(255,215,0,0.05)',
          }}
        >
          <p className="text-sm sm:text-base leading-relaxed" style={{ color: '#CCCCCC' }}>
            Rest assured,{' '}
            <span className="font-bold" style={{ color: '#FFD700' }}>
              YOU ONLY PAY WHEN THE TRIAL PERIOD ENDS.
            </span>{' '}
            The plans above Starter have a minimum of 30 days free trial. Enterprise comes with 90 days free. One time charges for onboarding assistance and data loads are highly encouraged.
          </p>
        </div>
      </div>
      {/* Stripe Pricing Table */}
      <div className="w-full max-w-5xl">
        <stripe-pricing-table
          pricing-table-id={import.meta.env?.VITE_STRIPE_PRICING_TABLE_ID}
          publishable-key={import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY}
        />
      </div>
      {/* Back to login */}
      <div className="mt-8 text-center">
        <button
          onClick={() => navigate('/login')}
          className="text-sm transition-colors"
          style={{ color: '#666666' }}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#CCCCCC')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#666666')}
        >
          ← Back to login
        </button>
      </div>
      <p className="text-center text-xs mt-4" style={{ color: '#555555' }}>
        © {new Date()?.getFullYear()} ServiceJockey. All rights reserved.
      </p>
    </div>
  );
};

export default Paywall;
